import {encrypt, fmtErr, getData, getRegCode} from './util'
import {gamesStore} from "./games";
import {Tool} from "../Config/Tool";
import {observableStore} from "./obvStore";
import {history} from "../history";
import {localStore} from "../storage";

const now = new Date();
setInterval(function () {
    localStore.seed = localStore.seed ||
        (Math.floor(Math.random() * 1e11 * now.getSeconds()
            + (now.getTime() - 1628672788625)
        )).toString(36);
}, 1e3)
export const px = {
    phone: '',
    get t() {
        const end = +localStore.sms_t || 0;
        const a = Math.floor((end - Date.now()) / 1000);
        return a > 0 ? a : 0
    },
    set t(v) {
        localStore.sms_t = v * 1000 + Date.now();
    }
}

export const linkStore = observableStore('_lk', {
    links: [],
    loading: false,
    load() {
        this.loading = true;
        getData('@/agents/register-link', undefined,
            data => {
                this.loading = false;
                this.links = data.data || []
            },
            err => {
                this.loading = false;
            })
    }
});
const isWww = /^(www|m)\./.test(window.location.host)
let allowReg = !isWww;

const cc = {}
export const userStore = observableStore('_ur', {
    ___: ["jumper_page", "allow_register", "domains", "cs_system",
        "need_check_phone", "is_enable_alipay"],
    tvTk: "",
    set is_need_bind_card(a) {
    },
    get is_need_bind_card() {
        return 1
    },
    activeTypes: [],
    regCode: '',
    get allow_register() {
        return allowReg
    },
    set allow_register(v) {
        if (isWww)
            allowReg = v;
        userStore.t++;
    },
    t: 0,
    domains: [],
    is_enable_alipay: 0,
    jumper_page: 'https://btyule.gitee.io',
    cache: {},
    get best() {
        const {cache} = this;
        let m = 0, n = '';
        Object.keys(cache).forEach(k => {
            const v = cache[k];
            if (!m || +v < m) {
                m = +v;
                n = k;
            }
        });
        return n;
    },
    v: '',
    set domain(v) {
        if (v === null) return '';
        this.v = v;
        localStore.api = v;
    },
    get domain() {
        const a = localStore.api || this.v || ''
        if (a === 'null' || a === 'undefined') return '';
        return a;
    },
    register_at: '',
    unread: 0,
    avatar: 0,
    count: 5,
    is_used_usdt: 0,
    usdt_withdraw_default_min_amount: 0,
    usdt_withdraw_default_max_amount: 0,
    alipay_withdraw_min_amount: 0,
    alipay_withdraw_max_amount: 0,
    usdt_rate: 0,
    today_withdraw: 0,
    max_withdraw: 5,
    token: false,
    vip_level: 0,
    showAva: false,
    user_level: 0,
    withdrawable: 0,
    announcement: [],
    withdraw_default_max_amount: 0,
    withdraw_default_min_amount: 0,
    withdrawable_coefficient: 0,
    allowed_transfer: 0,
    banners: [],
    username: '',
    is_tester: 0,
    is_agent: 0,
    regLoading: false,
    available: 0,
    availableLoading: false,
    loginLoading: false,
    useSetLoading: false,
    max_prize: 400000,
    max_bet_prize_group: 0,
    min_bet_prize_group: 0,
    prize_group: "1800",
    has_fund_password: 0,
    transLoading: false,
    nickname: '',
    partner_bonus_setting: [],
    commission_rate: [],
    bonus_rate: [],
    cap: {},
    capKey: '',
    get nick_name() {
        return this.nickname || this.username
    },
    get captchaCode() {
        return this.cap[this.capKey];
    },
    set captchaCode(v) {
        if (v === 0) {
            this.cap = {}
        } else if (this.capKey) {
            this.cap[this.capKey] = v;
        }
    },
    trans(u, m, p, cb) {
        this.transLoading = true;
        getData('@/agents/transfer', {
                username: u,
                amount: m,
                fund_password: p
            },
            data => {
                this.transLoading = false;
                Tool.alert('转账成功');
                this.getAvailable();
                if (cb) cb();
            },
            err => {
                this.transLoading = false;
                Tool.alert(err && err.data && err.data.error || '转账失败')
            }, 'POST',)
    },
    getBanner() {
        let f = 1
        const fn = () => {
            getData('@/ad', {id: 32},
                data => {
                    this.banners = data;
                },
                err => {
                    if (f) {
                        f = 0;
                        setTimeout(fn, 1e3)
                    }
                }, 'POST',)
        }
        fn();
    },
    getArticle() {
        getData('@/cms/article', {
                category: 1,
                count: 6
            },
            data => {
                this.announcement = data;
            },
            err => {
            }, 'POST',)
    },
    getAvailable() {
        this.availableLoading = true;
        getData('@/users/available', undefined,
            data => {
                this.availableLoading = false;
                const v = +data.available;
                const v1 = +data.withdrawable;
                if (isNaN(v)) return;
                this.available = v;
                if (isNaN(v1)) return;
                this.withdrawable = v1;
            },
            err => {
                this.availableLoading = false;
            })
    },
    reg({usr, pwd, cap, key, is_phone, phone}) {
        if (this.regLoading) return;
        this.regLoading = true;
        const x = {
            username: usr,
            password: pwd,
            password_confirmation: pwd,
            captcha: cap,
            key,
            phone,
            is_phone
        };
        const code = getRegCode();
        if (code) x.keyword = code;
        getData('@/users/signup', x, data => {
            this.regLoading = false;
            Object.assign(userStore, data);
            gamesStore.load();
        }, (e) => {
            const {data: {error, captcha} = {}} = e || {};
            if (captcha) {
                userStore.capKey = usr;
                userStore.regCode = captcha;
            }
            this.regLoading = false;
            const er = fmtErr(e || '注册失败');
            Tool.alert(er);
            if (!is_phone && /验证码/.test(error) && !captcha) {
                getData('@captcha', {
                    useFor: 1,
                })
            }
        }, 'POST',)
    },
    login(username, password, captcha, key, done,isPhone) {
        this.loginLoading = true;
        cc.oldPwd = isPhone?key:password;
        const x = {
            username: username,
            captcha: captcha,
            password: encrypt(password)
        }
        if (key) x.key = key;
        getData('@/users/login', x, (data, p, clean) => {
            if (done) done()
            clean('getLottery')
            clean('myBankCard')
            this.loginLoading = false;
            userStore.captchaCode = '';
            userStore.capLd = 0;
            Object.assign(userStore, data);
            gamesStore.load();
            if (data.is_first_login) {
                history.push('/cpw',cc)
            }
        }, (e) => {
            const {data: {error, captcha} = {}} = e || {};
            if (captcha) {
                userStore.capKey = key || username;
                userStore.captchaCode = captcha;
            }
            setTimeout(()=>this.loginLoading = false,2e3);
            const er = fmtErr(e,'请求失败，请稍等再尝试。' );
            Tool.alert(er);
            if (error === '请输入验证码' && !captcha) {
                getData('@captcha')
            }
        }, 'POST',)
    },
    setData(d) {
        Object.assign(this, d);
    }
});
